export const site = "68cfb0f5f7541c4af07623d9"  // Site ID NEW88

// export const Endpoint = "http://localhost:3002"
export const Endpoint = "https://api-freecode.781243555.com"